const back_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth: "F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup: "F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    radioGroup: "F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "Please identify the evidence reviewed and the date range",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Evidence reviewed",
      number: "0",
    },
    maxLength: 2000,
    presidence: "Yes",
    radioGroup: "F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName: "F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
    textanswer: "",
  },

  {
    question:
      "Is ##name## taking continuous medication to control their HIV-related Illness?",
    sub: "Medication",
    type: "yesno",
    show: true,
    section: {
      page: "2",
      title: "Medical History",
      number: "2B",
    },

    srcMap: "keyLink1",
    srcMapAnswer: "keyLinkAnswer1",
    // srcMapNo: "keyLink1",
    // srcMapAnswerNo: "keyLinkAnswer2",

    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_2[0].Yes1[0]",
    dbqName_no: "F[0].Page_2[0].No1[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please list medication",
    textdbqName: "F[0].Page_2[0].listonly[0]",
    textanswer: "",
  },
  {
    question:
      "Does ##name## experience any complications due to current or previous medications taken for HIV-related Illness?",
    sub: "Medication complications",
    type: "yesno",
    show: true,
    section: {
      page: "2",
      title: "Medical History",
      number: "2C",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_2[0].Yes2[0]",
    dbqName_no: "F[0].Page_2[0].No2[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please list medication",
    textdbqName: "F[0].Page_2[0].veteranhave[0]",
    textanswer: "",
  },

  {
    question:
      "Do ##name## have any signs, symptoms or findings attributable to an HIV-related illness?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "3A",
    },
    presidence: "Yes",
    ref: 3,
    dbqName_yes: "F[0].Page_2[0].Yes3[0]",
    dbqName_no: "F[0].Page_2[0].No3[0]",
    answer: "",
  },
  {
    question:
      "Signs, symptoms or findings attributable to an HIV-related illness",
    sub: "Check all that apply",
    type: "radioModal",
    multi: false,
    show: false,
    refId: 1,
    srcMap: "keyLink1",
    small: true,
    cols: 2,
    section: {
      page: "2",
      title: "AID AND ATTENDANCE",
      number: "3B",
    },
    questions: [
      {
        main: "Constitutional Symptoms (fever, weight loss, fatigue, malaise, decreased appetite, etc.)",
        dbqName: "F[0].Page_2[0].FindingsA[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_2[0].describecont[0]",
        placeholder1: "Describe constitutional symptoms",
        subItems: [
          {
            main: "Refractory",
            dbqName: "F[0].Page_2[0].Refractory1[0]",
            colWidth: 6,
            answer: "",
            srcMapAnswer: "keyLinkAnswer2",
          },
          {
            main: "Recurrent",
            dbqName: "F[0].Page_2[0].Recurrent1[0]",
            colWidth: 6,
            answer: "",
            srcMapAnswer: "keyLinkAnswer3",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate frequency and severity",
      },
      {
        main: "None",
        dbqName: "pass_this_question",
        answer: "",
      },
    ],
  },
  {
    question: "Diarrhea attributable to an HIV-Related illness",
    sub: "Check all that apply",
    type: "radioModal",
    multi: false,
    show: false,
    refId: 2,
    small: true,
    cols: 2,
    section: {
      page: "2",
      title: "AID AND ATTENDANCE",
      number: "3C",
    },
    questions: [
      {
        main: "Diarrhea",
        dbqName: "F[0].Page_2[0].FindingsB[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_2[0].describecolon[0]",
        placeholder1: "Describe",
        subItems: [
          {
            main: "Intermittent",
            dbqName: "F[0].Page_2[0].Refractory[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "More than Intermittent",
            dbqName: "F[0].Page_2[0].Intermittent[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate frequency and severity",
      },
      {
        main: "None",
        dbqName: "pass_this_question",
        answer: "",
      },
    ],
  },
  {
    question: "Weight loss attributable to an HIV-Related illness",
    sub: "Check all that apply",
    type: "radioModal",
    multi: false,
    show: false,
    refId: 3,
    srcMap: "keyLink1",
    small: true,
    cols: 2,
    section: {
      page: "2",
      title: "AID AND ATTENDANCE",
      number: "3D",
    },
    questions: [
      {
        main: "Weight Loss",
        dbqName: "F[0].Page_2[0].FindingsC[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_2[0].weight1[0]",
        placeholder1: "Provide baseline weight",
        text2: "",
        dbqName2: "F[0].Page_2[0].weight2[0]",
        placeholder2: "Provide current weight",
        subItems: [
          {
            main: "Progressive weight loss",
            dbqName: "F[0].Page_2[0].Refractory[1]",
            colWidth: 6,
            answer: "",
            srcMapAnswer: "keyLinkAnswer4",
          },
          {
            main: "Pathological weight loss",
            dbqName: "F[0].Page_2[0].Intermittent[1]",
            colWidth: 6,
            answer: "",
            srcMapAnswer: "keyLinkAnswer5",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Weight Loss",
      },
      {
        main: "None",
        dbqName: "pass_this_question",
        answer: "",
      },
    ],
  },

  {
    question:
      "Does ##name## have any secondary diseases attributable to HIV-related illness?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "SECONDARY DISEASES",
      number: "4A",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_3[0].Yes7[0]",
    dbqName_no: "F[0].Page_3[0].No7[0]",
    answer: "",
  },
  {
    question: "Secondary diseases attributable to HIV-related illness",
    sub: "",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    section: {
      page: "3",
      title: "SECONDARY DISEASES",
      number: "4A",
    },
    srcMap: "keyLink1",
    cols: 2,
    small: true,
    questions: [
      {
        main: "Musculoskeletal System (Joints/Muscles)",
        dbqName: "F[0].Page_3[0].complications2[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Organs of Special Sense",
        dbqName: "F[0].Page_3[0].complications3[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Respiratory System",
        dbqName: "F[0].Page_3[0].complications4[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Cardiovascular System",
        dbqName: "F[0].Page_3[0].complications5[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Digestive System",
        dbqName: "F[0].Page_3[0].complications6[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Genitourinary System",
        dbqName: "F[0].Page_3[0].complications7[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Endocrine (Diabetes)",
        dbqName: "F[0].Page_3[0].complications8[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "HEMATOLOGIC AND LYMPHATIC",
        dbqName: "F[0].Page_3[0].complications9[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Reproductive System",
        dbqName: "F[0].Page_3[0].complications10[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Dermatological System (Skin)",
        dbqName: "F[0].Page_3[0].complications11[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Ophthamological System",
        dbqName: "F[0].Page_3[0].complications12[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Neurological conditions",
        dbqName: "F[0].Page_3[0].complications10[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
      {
        main: "Mental/Psychological System",
        dbqName: "F[0].Page_3[0].complications11[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer7",
      },
      {
        main: "Dental and Oral Conditions",
        dbqName: "F[0].Page_3[0].complications12[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer6",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## now have any HIV-related opportunistic infections or oncologic conditions?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "INFECTIOUS AND ONCOLOGIC COMPLICATIONS",
      number: "5A",
    },
    presidence: "Yes",
    ref: 2,
    dbqName_yes: "F[0].Page_3[0].Yes8[0]",
    dbqName_no: "F[0].Page_3[0].No8[0]",
    answer: "",
  },
  {
    question: "HIV-related opportunistic infections or oncologic conditions",
    sub: "",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    section: {
      page: "3",
      title: "INFECTIOUS AND ONCOLOGIC COMPLICATIONS",
      number: "5A",
    },
    srcMap: "keyLink1",
    cols: 2,
    small: true,
    questions: [
      {
        main: "Candidiasis of the bronchi, trachea, esophagus, or lungs",
        dbqName: "F[0].Page_3[0].hivrelated1[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Invasive cervical cancer",
        dbqName: "F[0].Page_3[0].hivrelated2[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },

      {
        main: "Coccidioidomycosis",
        dbqName: "F[0].Page_3[0].hivrelated3[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Cryptococcosis",
        dbqName: "F[0].Page_3[0].hivrelated4[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Cryptosporidiosis",
        dbqName: "F[0].Page_3[0].hivrelated5[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Cytomegalovirus (particularly CMV retinitis)",
        dbqName: "F[0].Page_3[0].hivrelated6[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },

      {
        main: "HIV-related encephalopathy",
        dbqName: "F[0].Page_3[0].hivrelated7[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Herpes simplex-chronic ulcers for greater than one month, or bronchitis, pneumonia, or esophagitis",
        dbqName: "F[0].Page_3[0].hivrelated8[0]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Histoplasmosis",
        dbqName: "F[0].Page_3[0].hivrelated1[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Isosporiasis (chronic intestinal)",
        dbqName: "F[0].Page_3[0].hivrelated2[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Kaposi's sarcoma",
        dbqName: "F[0].Page_3[0].hivrelated3[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Lymphoma",
        dbqName: "F[0].Page_3[0].hivrelated4[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Mycobacterium avium complex",
        dbqName: "F[0].Page_3[0].hivrelated5[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Tuberculosis",
        dbqName: "F[0].Page_3[0].hivrelated6[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Pneumocystis jirovecii (carinii) pneumonia",
        dbqName: "F[0].Page_3[0].hivrelated7[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Pneumonia, recurrent",
        dbqName: "F[0].Page_3[0].hivrelated8[1]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Progressive multifocal leukoencephalopathy",
        dbqName: "F[0].Page_3[0].hivrelated1[2]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Salmonella septicemia, recurrent",
        dbqName: "F[0].Page_3[0].hivrelated2[2]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Toxoplasmosis of the brain",
        dbqName: "F[0].Page_3[0].hivrelated3[2]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
      {
        main: "Wasting syndrome due to HIV",
        dbqName: "F[0].Page_3[0].hivrelated4[2]",
        answer: "",
        srcMapAnswer: "keyLinkAnswer8",
      },
    ],
    answer: "",
  },
  {
    question:
      "For each checked conditions on the previous screen, describe (providing approx. date of onset, a brief summary of symptoms, treatment and course)",
    sub: "",
    type: "textarea",
    show: false,
    refId: 2,
    maxLength: 500,
    section: {
      page: "4",
      title: "INFECTIOUS AND ONCOLOGIC COMPLICATIONS",
      number: "5B",
    },
    options: [],
    dbqName: "F[0].Page_4[0].describechecked[0]",
    answer: "",
  },

  {
    question: "Does ##name## have Recurrent Opportunistic Infections?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "4",
      title: "INFECTIOUS AND ONCOLOGIC COMPLICATIONS",
      number: "5C",
    },
    srcMap: "keyLink1",
    srcMapAnswer: "keyLinkAnswer9",
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_4[0].Yes9[0]",
    dbqName_no: "F[0].Page_4[0].No9[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please describe the brief summary of symptoms, treatment and course",
    textdbqName: "F[0].Page_4[0].ifeyestheveteran[0]",
    textanswer: "",
  },

  {
    question:
      "Based on symptoms and findings from this exam, complete the following section to provide a summary of the severity of ##name##'s HIV-related condition",
    sub: "",
    type: "radioTiles",
    multi: true,
    show: true,
    note: "For VA purposes, approved medications include medications prescribed as part of a research protocol at an accredited medical institution.",
    section: {
      page: "4",
      title: "SUMMARY",
      number: "6A",
    },
    destMap: "keyLink1",
    cols: 2,
    small: true,
    questions: [
      {
        main: "Asymptomatic, with or without lymphadenopathy or decreased T4 cell count",
        dbqName: "F[0].Page_4[0].level1[0]",
        answer: "",
      },
      {
        main: "Symptomatic, development of HIV-related constitutional symptoms",
        dbqName: "F[0].Page_4[0].level2[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer2",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, this person has symptoms i.e fever, weight loss, fatigue, malaise, decreased appetite, etc.",
      },
      {
        main: "Current T4 cell count between 200 and 500",
        dbqName: "F[0].Page_4[0].level3[0]",
        answer: "",
      },
      {
        main: "Use of approved medication(s)",
        dbqName: "F[0].Page_4[0].level3[1]",
        answer: "",
        destMapAnswer: "keyLinkAnswer1",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, this person is taking continuous medication to control",
      },
      {
        main: "Evidence of depression with employment limitations",
        dbqName: "F[0].Page_4[0].level4[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer7",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, there is evidence of depression with employment limitations",
      },
      {
        main: "Evidence of memory loss with employment limitations",
        dbqName: "F[0].Page_4[0].level4[1]",
        answer: "",
        destMapAnswer: "keyLinkAnswer7",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, there is evidence of memory loss with employment limitations",
      },

      {
        main: "Recurrent constitutional symptoms, intermittent diarrhea, and on approved medication(s)",
        dbqName: "F[0].Page_4[0].level5[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer3",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, this person has recurrent symptoms i.e fever, weight loss, fatigue, malaise, decreased appetite, etc.",
      },
      {
        main: "Current T4 cell count less than 200",
        dbqName: "F[0].Page_4[0].level6[0]",
        answer: "",
      },
      {
        main: "Refractory constitutional symptoms, diarrhea and pathological weight loss",
        dbqName: "F[0].Page_4[0].level9[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer5",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, this person has pathological weight loss",
      },
      {
        main: "Development of AIDS-related opportunistic infection or neoplasm",
        dbqName: "F[0].Page_4[0].level11[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer9",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, patient has AIDS-related opportunistic infection or neoplasm",
      },
      {
        main: "AIDS with recurrent opportunistic infections",
        dbqName: "F[0].Page_4[0].level12[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer8",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, patient has AIDS with recurrent opportunistic infections",
      },
      {
        main: "AIDS with secondary diseases afflicting multiple body systems",
        dbqName: "F[0].Page_4[0].level13[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer6",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, patient has AIDS with secondary diseases afflicting multiple body systems",
      },
      {
        main: "HIV-related illness with debility and progressive weight loss",
        dbqName: "F[0].Page_4[0].level14[0]",
        answer: "",
        destMapAnswer: "keyLinkAnswer4",
        isLinked: false,
        destMapMessage:
          "Are you sure to unselect? Your previous response suggests, this person has progressive weight loss",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does the ##name##'s HIV-related illness impact their ability to work?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "5",
      title: "INFECTIOUS AND ONCOLOGIC COMPLICATIONS",
      number: "9A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_5[0].Yes18[0]",
    dbqName_no: "F[0].Page_5[0].No18[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please describe impact, providing one or more examples",
    textdbqName: "F[0].Page_5[0].ifyesdescribeimpact[0]",
    textanswer: "",
  },

  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    maxLength: 300,
    show: true,
    section: {
      page: "5",
      title: "REMARKS",
      number: "10A",
    },
    options: [],
    dbqName: "F[0].Page_5[0].REMARKSIfany[0]",
    answer: "",
  },
];

export default back_questions;
